import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { API } from "../constants";

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axios.post(`${API}/contact/submit`, form);
      toast.success("Message sent successfully! We'll get back to you soon.");
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="min-h-[calc(100vh-8rem)] py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h1 className="font-heading text-4xl font-bold text-white mb-4" data-testid="contact-title">Get in Touch</h1>
              <p className="neon-white-text mb-8">Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#4B3F8F]/30 flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                  </div>
                  <div><p className="text-white font-semibold">Address</p><p className="neon-white-text text-sm">713 Consulting & Development<br/>1942 W. Gray St., Box #1259<br/>Houston, TX 77019</p></div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#4B3F8F]/30 flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
                  </div>
                  <div><p className="text-white font-semibold">Phone</p><p className="neon-white-text text-sm">713.328.9736</p></div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#4B3F8F]/30 flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>
                  </div>
                  <div><p className="text-white font-semibold">Company</p><a href="https://713consulting.net/" target="_blank" rel="noopener noreferrer" className="neon-green-text text-sm hover:underline">713 Consulting & Development</a></div>
                </div>
              </div>
            </div>
            <div className="card-glass p-8" data-testid="contact-form">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div><label className="block text-sm text-[#E8E4DC] mb-1">Name</label><input type="text" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="input-dark w-full" required data-testid="contact-name" /></div>
                <div><label className="block text-sm text-[#E8E4DC] mb-1">Email</label><input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="input-dark w-full" required data-testid="contact-email" /></div>
                <div><label className="block text-sm text-[#E8E4DC] mb-1">Subject</label><input type="text" value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} className="input-dark w-full" required data-testid="contact-subject" /></div>
                <div><label className="block text-sm text-[#E8E4DC] mb-1">Message</label><textarea value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} className="input-dark w-full h-32 resize-none" required data-testid="contact-message" /></div>
                <button type="submit" disabled={isLoading} className="btn-primary w-full" data-testid="contact-submit">{isLoading ? "Sending..." : "Send Message"}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
